/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowRightIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m35.578 21.038-8.504 8.494c-.626.624-1.564.624-2.126 0-.626-.562-.626-1.5 0-2.124l5.94-5.933H5.501c-.876 0-1.501-.624-1.501-1.498a1.48 1.48 0 0 1 1.5-1.5h25.388l-5.94-5.932c-.626-.562-.626-1.499 0-2.123.563-.563 1.5-.563 2.126 0l8.504 8.555a1.47 1.47 0 0 1 0 2.061"/>}
        </IconWrapper>);
}
